import styled, { css } from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';
import { FontFamily } from 'styles/style-variables/font-family';
import { TransitionTime } from 'styles/style-variables/transition-time';

export const Tooltip = styled.div`
  position: relative;
  display: flex;
`;

export const TooltipIcon = styled.div<{ $tooltipIcon?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;

    & > svg {
      z-index: 1;

      path {
        ${({ $tooltipIcon }) =>
          !$tooltipIcon &&
          css`
            fill: ${EColors.Gray3};
          `}
        transition: fill ${TransitionTime.Hover} ease;
      }
    }
  }
`;

export const TooltipContent = styled.div<{ $isContentShown: boolean; $isLeftAligned: boolean }>`
  position: absolute;
  bottom: 24px;
  ${({ $isLeftAligned }) => ($isLeftAligned ? 'left: 0' : 'right: 0')};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 208px;
  padding: 8px;
  border-radius: 8px;
  ${({ $isContentShown }) =>
    $isContentShown
      ? css`
          z-index: 2;
          opacity: 1;
        `
      : css`
          z-index: -1;
          opacity: 0;
        `}
  background: ${EColors.White};
  box-shadow:
    rgb(50 50 93 / 25%) 0 13px 27px -5px,
    rgb(0 0 0 / 30%) 0 8px 16px -8px;
  font-family: ${FontFamily.Montserrat};
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.2px;
  text-transform: initial;
  white-space: normal;
  overflow-wrap: break-word;
  color: ${EColors.Gray1Text};
  transition: all ${TransitionTime.Hover} ease;

  @media (max-width: ${BreakPoint.MobileTop}) {
    min-width: 120px;
  }
`;
